const APIURL = process.env.REACT_APP_REST_ENDPOINT;

// Submits a warranty claims form
const submitWarrantyClaimForm = async (values, authToken) => {
  const response = await fetch(`${APIURL}/WarrantyClaims`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(values)
  });

  const { success, messages, ...rest } = await response.json();
  // DO NOT use response.ok to error this, pass the error messages
  // TODO: be nice to match the field name as key paired with message string
  // so that we can error fields where BE is pointing out (eg { 'customer_name': 'required' } )
  if (success === false) {
    // messages expected to be an array of strings
    return { success: false, errors: messages || [response.statusText] };
  }

  return { success: true, ...rest };
};

// Get a single submitted warranty-claim by ID.
const getWarrantyClaim = async (id, authToken) => {
  const response = await fetch(`${APIURL}/WarrantyClaims/${id}`, {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  return await response.json();
};

const restFormSubmitAPIs = {
  submitWarrantyClaimForm,
  getWarrantyClaim
};

export default restFormSubmitAPIs;
